import BlockContent from '@sanity/block-content-to-react';
import { graphql } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ALL_LANGS } from '../constants';
import { localize } from '../utils/sanity';

import serializers from '../serializers';

import PageSEO from '../components/PageSEO';
import SanityLayout from '../components/ui/SanityLayout';
import { RawPortableText } from '../types/types';
import { withI18n } from '../utils/hocs';
import * as styles from './LegalDocumentationPage.module.scss';

interface LocalizedQueryData {
  sanityLegalDocumentationPage: {
    title: string;
    slug: {
      current: string;
    };
    body: RawPortableText;
  };
}

export const query = graphql`
  # "-b23d8165-bcea-5b76-9907-ef735c7b4303"
  query GetLegalDocumentationById($id: String!) {
    sanityLegalDocumentationPage(_id: { eq: $id }) {
      title {
        ...LocaleStringFragment
      }
      body {
        ...LocaleLegalDocumentationPortableText
      }
    }
  }
`;

const LegalDocumentationPage = ({ data }: any): React.ReactElement => {
  const { i18n, t } = useTranslation();
  const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
  const localizedData: LocalizedQueryData = localize(data, langs);
  const { title, body } = localizedData.sanityLegalDocumentationPage;

  return (
    <SanityLayout headerWithOpaqueBackground>
      <PageSEO defaultTitle={title} />
      <section className={styles.section}>
        <div className={styles.container}>
          <h1>{title}</h1>
          <BlockContent
            className={styles.description}
            renderContainerOnSingleChild
            blocks={body}
            serializers={serializers}
          />
        </div>
      </section>
    </SanityLayout>
  );
};

export default withI18n(LegalDocumentationPage);
